export default "__VITE_ASSET__B940z7If__"